<svg class="absolute w-full aspect-video" width="1280" height="720" viewBox="0 0 1280 720" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <g clip-path="url(#clip0_6906_47775)">
  <rect width="1280" height="720" transform="translate(1280 720) rotate(-180)" fill="black"/>
  <g clip-path="url(#clip1_6906_47775)">
  <rect x="-162" y="-120" width="1440" height="810" fill="white"/>
  <g opacity="0.6" filter="url(#filter0_f_6906_47775)">
  <ellipse cx="1152" cy="370" rx="306" ry="395" fill="#F7FBA5"/>
  </g>
  <g filter="url(#filter1_f_6906_47775)">
  <ellipse cx="813" cy="362" rx="306" ry="395" fill="#F7FBA5"/>
  </g>
  <g filter="url(#filter2_f_6906_47775)">
  <ellipse cx="1113" cy="-185" rx="581" ry="395" fill="#8F00FF"/>
  </g>
  <g filter="url(#filter3_f_6906_47775)">
  <ellipse cx="382" cy="-317" rx="490" ry="395" fill="#8F00FF"/>
  </g>
  <g filter="url(#filter4_f_6906_47775)">
  <ellipse cx="-162" cy="329" rx="490" ry="602" fill="#8F00FF"/>
  </g>
  <g opacity="0.62" filter="url(#filter5_f_6906_47775)">
  <ellipse cx="313" cy="485.5" rx="559" ry="560.5" fill="#F7FBA5"/>
  </g>
  <g opacity="0.54" filter="url(#filter6_f_6906_47775)">
  <ellipse cx="350" cy="360" rx="408" ry="405" fill="#8F00FF"/>
  </g>
  <g opacity="0.73" filter="url(#filter7_f_6906_47775)">
  <ellipse cx="457" cy="398.5" rx="367" ry="485.5" transform="rotate(11.5872 457 398.5)" fill="#F7FBA5"/>
  </g>
  <g filter="url(#filter8_f_6906_47775)">
  <ellipse cx="680.76" cy="574.375" rx="376.5" ry="503.5" transform="rotate(-11.6972 680.76 574.375)" fill="#F7FBA5"/>
  </g>
  </g>
  <line x1="6.71455e-08" y1="108.232" x2="1280" y2="108.232" stroke="white" stroke-width="1.53611"/>
  <line x1="108.232" y1="222" x2="108.232" y2="-1.52924e-05" stroke="white" stroke-width="1.53611"/>
  <line x1="1172.23" y1="720" x2="1172.23" y2="-3.35727e-08" stroke="white" stroke-width="1.53611"/>
  </g>
  <defs>
  <filter id="filter0_f_6906_47775" x="646" y="-225" width="1012" height="1190" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
  <feGaussianBlur stdDeviation="100" result="effect1_foregroundBlur_6906_47775"/>
  </filter>
  <filter id="filter1_f_6906_47775" x="307" y="-233" width="1012" height="1190" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
  <feGaussianBlur stdDeviation="100" result="effect1_foregroundBlur_6906_47775"/>
  </filter>
  <filter id="filter2_f_6906_47775" x="306" y="-806" width="1614" height="1242" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
  <feGaussianBlur stdDeviation="113" result="effect1_foregroundBlur_6906_47775"/>
  </filter>
  <filter id="filter3_f_6906_47775" x="-334" y="-938" width="1432" height="1242" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
  <feGaussianBlur stdDeviation="113" result="effect1_foregroundBlur_6906_47775"/>
  </filter>
  <filter id="filter4_f_6906_47775" x="-878" y="-499" width="1432" height="1656" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
  <feGaussianBlur stdDeviation="113" result="effect1_foregroundBlur_6906_47775"/>
  </filter>
  <filter id="filter5_f_6906_47775" x="-446" y="-275" width="1518" height="1521" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
  <feGaussianBlur stdDeviation="100" result="effect1_foregroundBlur_6906_47775"/>
  </filter>
  <filter id="filter6_f_6906_47775" x="-258" y="-245" width="1216" height="1210" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
  <feGaussianBlur stdDeviation="100" result="effect1_foregroundBlur_6906_47775"/>
  </filter>
  <filter id="filter7_f_6906_47775" x="-115.605" y="-282.853" width="1145.21" height="1362.71" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
  <feGaussianBlur stdDeviation="100" result="effect1_foregroundBlur_6906_47775"/>
  </filter>
  <filter id="filter8_f_6906_47775" x="98.1113" y="-124.613" width="1165.3" height="1397.98" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
  <feGaussianBlur stdDeviation="100" result="effect1_foregroundBlur_6906_47775"/>
  </filter>
  <clipPath id="clip0_6906_47775">
  <rect width="1280" height="720" fill="white" transform="translate(1280 720) rotate(-180)"/>
  </clipPath>
  <clipPath id="clip1_6906_47775">
  <rect width="1065" height="108" fill="white" transform="translate(1173 108) rotate(-180)"/>
  </clipPath>
  </defs>
  </svg>
  
  